import { Cookie } from 'core-events/components';
import { unstable_rethrow } from 'next/navigation';
import { useCallback } from 'react';

import { LoggerFactory } from '@videoblocks/typescript-logger';

import { GoogleLoginSuccessCallback } from '../../../components/google-login/useGoogleLoginIFrameEventListener';
import { getCookie } from '../../../components/lib/cookies/getCookie';
import { useSignUpContext } from './SignUpContext';
import { SignUpFormPayload } from './SignUpFormPayload';
import { SignUpParams } from './SignUpParams';
import { signUpAction } from './signUpAction';

const logger = LoggerFactory.create('useGoogleSignUpCallback');

export function useGoogleSignUpCallback({
    planCode,
    redirectAfterRegister,
    externalAuthId,
}: SignUpParams = {}): GoogleLoginSuccessCallback {
    const { setError, setSubmitText } = useSignUpContext();

    return useCallback<GoogleLoginSuccessCallback>(
        (response) => {
            signUpAction({
                signupType: 'google',
                uniqueId: getCookie(Cookie.Vid),
                googleCredential: response.credential,
                planCode,
                redirectAfterRegister,
                externalAuthId,
            } satisfies SignUpFormPayload)
                .then((result) => {
                    if (result && 'error' in result && result.error) {
                        setError(result.error);
                        setSubmitText('Create Account');
                    }
                })
                .catch((e: unknown) => {
                    // Let Next.js control-flow errors (e.g. redirect from signUpAction) bubble up.
                    unstable_rethrow(e);
                    logger.error(e);
                    setError('Oops! Something went wrong. Please try again.');
                    setSubmitText('Create Account');
                });
        },
        [setError, setSubmitText, planCode, redirectAfterRegister, externalAuthId],
    );
}
